import { createReducer, on, Action } from '@ngrx/store';

import {
    AddItemsWishlistAction,
    ClearWishlistAction,
    DeleteItemWishlistAction,
    GetWishlistAction,
    SetWishlistTotalItems,
} from './wishlist-commands.actions';
import {
    AddItemWishlistErrorAction,
    AddItemsWishlistSuccessAction,
    DeleteItemWishlistErrorAction,
    DeleteItemWishlistSuccessAction,
    GetWishlistErrorAction,
    GetWishlistSuccessAction,
} from './wishlist-events.actions';
import { wishlistInitialState, WishlistsState } from './wishlist.state';

/**
 * Definicion de las acciones que implementa el "walletReducer"
 */
export const wishlistReducerDefinition = createReducer(
    wishlistInitialState,
    on(
        GetWishlistAction,
        (state: WishlistsState): WishlistsState => {
            return {
                ...state,
                loaded: false,
                loading: true,
                error: false,
            };
        },
    ),
    on(
        GetWishlistSuccessAction,
        (state: WishlistsState, buylater): WishlistsState => {
            return {
                ...state,
                buylater,
                totalItems: buylater?.items?.length || 0,
                wishlistEmpty: !buylater?.items || buylater.items.length === 0,
                loaded: true,
                loading: false,
                error: false,
            };
        },
    ),
    on(
        GetWishlistErrorAction,
        (state: WishlistsState): WishlistsState => {
            return {
                ...state,
                loaded: false,
                loading: false,
                error: true,
            };
        },
    ),
    on(
        ClearWishlistAction,
        (state: WishlistsState): WishlistsState => {
            return {
                ...state,
                buylater: {},
                totalItems: 0,
                wishlistEmpty: true,
                loaded: true,
                loading: false,
                error: false,
            };
        },
    ),
    on(
        AddItemsWishlistAction,
        (state: WishlistsState): WishlistsState => {
            return {
                ...state,
                loaded: false,
                loading: true,
                error: false,
            };
        },
    ),
    on(
        AddItemsWishlistSuccessAction,
        (state: WishlistsState, { wishlist }): WishlistsState => {
            return {
                ...state,
                buylater: wishlist,
                totalItems: wishlist.items.length,
                wishlistEmpty: false,
                loaded: true,
                loading: false,
                error: false,
            };
        },
    ),
    on(
        AddItemWishlistErrorAction,
        (state: WishlistsState): WishlistsState => {
            return {
                ...state,
                loaded: false,
                loading: false,
                error: true,
            };
        },
    ),
    on(
        DeleteItemWishlistAction,
        (state: WishlistsState): WishlistsState => {
            return {
                ...state,
                loaded: false,
                loading: true,
                error: false,
            };
        },
    ),
    on(
        DeleteItemWishlistSuccessAction,
        (state: WishlistsState, { wishlist }): WishlistsState => {
            return {
                ...state,
                buylater: wishlist, // a.k.a the wish list itself
                totalItems: wishlist.items.length,
                wishlistEmpty: wishlist?.items ? wishlist.items.length === 0 : true,
                loaded: true,
                loading: false,
                error: false,
            };
        },
    ),
    on(
        DeleteItemWishlistErrorAction,
        (state: WishlistsState): WishlistsState => {
            return {
                ...state,
                loaded: false,
                loading: false,
                error: true,
            };
        },
    ),
    on(
        SetWishlistTotalItems,
        (state: WishlistsState, { totalItems }): WishlistsState => {
            return {
                ...state,
                totalItems,
                wishlistEmpty: totalItems === 0,
            };
        },
    ),
);

/**
 * Reducer para el wallet
 */
export function wishlistReducer(state: WishlistsState, action: Action): WishlistsState {
    return wishlistReducerDefinition(state, action);
}
